import React, { useRef } from "react";
import SortableContainerWithoutContext from "src/components/Sortable/ContainerWithoutContext";
import { verticalListSortingStrategy } from "src/components/Sortable/Container/strategy";
import SortableItem from "src/components/Sortable/Item";
import Droppable from "src/components/Sortable/Droppable";
import SortableHandle from "src/components/Sortable/Handle";
import { useAuth } from "src/context/Auth/context";
import { PermissionEnum } from "src/context/Auth/interface";
import * as Matrix from "./styles";
import { IMatrixPriorityItem, ISwotItem } from "../../interface";
import CardSwotMatrix from "../SWOTCard";
import { IRefSwotDetailModal } from "../SWOTItens/components/interface";
import  SwotDetailModal  from "../SWOTItens/components/ItemDetail";

const MatrixItem: React.FC<IMatrixPriorityItem> = ({
	number,
	color,
	data,
	titles
}) => {
	const refModalDetailItem = useRef<IRefSwotDetailModal>(null);
	const { checkIfHasSpecificPermission } = useAuth();
	
	const permisionToCreateUpdate = checkIfHasSpecificPermission("/analysis/swot", PermissionEnum.CREATE_UPDATE);

	return (
		<>
			<Matrix.WrapQuadrant>
				<Matrix.WrapTitle color={color}>
					<Matrix.WrapTitleQuadrant>
						<span>{titles.title1}</span>
					</Matrix.WrapTitleQuadrant>
				</Matrix.WrapTitle>
				<Matrix.WrapPanel>
					<Matrix.PanelHeading>
						{titles.heading}
					</Matrix.PanelHeading>
					<Matrix.PanelContent>
						<SortableContainerWithoutContext
							items={data}
							strategy={verticalListSortingStrategy}
						>
						 <Droppable id={number} flexDirection="column">
								{data && data.map((item: ISwotItem) => (
									<React.Fragment key={item.id}>
										{permisionToCreateUpdate ? (
											<SortableItem id={item.id}>
												<SortableHandle>
													<CardSwotMatrix 
														data={item} 
														onClick={(tab:"detail"|"bonds") => {refModalDetailItem?.current?.actionOpenModal(item.mes002Id,tab === "detail" ? 0:1); }}
													/>
												</SortableHandle>
											</SortableItem>
										)  : (
											<SortableItem id={item.id} disabled>
												<CardSwotMatrix 
													data={item} 
													disabled
													onClick={(tab:"detail"|"bonds") => {refModalDetailItem?.current?.actionOpenModal(item.mes002Id,tab === "detail" ? 0:1); }}
												/>
											</SortableItem>
										)}	
									</React.Fragment>				
								))}
							</Droppable> 
						</SortableContainerWithoutContext>
					</Matrix.PanelContent>
				</Matrix.WrapPanel>
			</Matrix.WrapQuadrant>
			<SwotDetailModal ref={refModalDetailItem}/>
		</>
	);};

export default MatrixItem;
